import { SendIcon } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import { Button } from '~/components/component-library'
import { SupportedChainId } from '~/constants/chains'
import { IAddress } from '~/types'

type SendNFTButtonProps = {
  sender: IAddress
  token: IAddress
  tokenId: bigint
  chainId: SupportedChainId
  isDisabled?: boolean
  disabledReason?: string
} & (
  | { asChild: true; children: React.ReactNode }
  | { asChild?: false; children?: never }
)

export const SendNFTButton = ({
  sender,
  token,
  tokenId,
  chainId,
  isDisabled = false,
  disabledReason,
  asChild = false,
  children,
}: SendNFTButtonProps) => {
  const buildQueryParams = () => {
    const params = new URLSearchParams({
      account: sender,
      token,
      tokenId: tokenId.toString(),
      chainId: chainId.toString(),
    })

    const queryString = params.toString()
    return queryString ? `?${queryString}` : ''
  }

  return (
    <SplitsLink path={`/send-nft${buildQueryParams()}`}>
      {asChild ? (
        children
      ) : (
        <Button
          variant="secondary"
          prefix={<SendIcon />}
          isDisabled={isDisabled}
          disabledReason={disabledReason}
        >
          Send
        </Button>
      )}
    </SplitsLink>
  )
}
